import Vue from 'vue'
import App from './person.vue'
import router from  './router'


Vue.config.productionTip = false

Vue.use(router)

/* eslint-disable no-new */
new Vue({
  el: '#person',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/personal/person.js